import { render, staticRenderFns } from "./AttachEmail.vue?vue&type=template&id=5d778dbc&scoped=true&"
import script from "./AttachEmail.vue?vue&type=script&lang=js&"
export * from "./AttachEmail.vue?vue&type=script&lang=js&"
import style0 from "./AttachEmail.vue?vue&type=style&index=0&id=5d778dbc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d778dbc",
  null
  
)

export default component.exports